module.exports = __webpack_public_path__ + "img/Burgundy.26d35f9b.png";